export default __webpack_public_path__ + "static/media/left-caret-icon.f26f186f.svg";